import React from 'react';
import { useI18n } from '../lib/i18n';
import { Globe } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';

export default function LanguageToggle({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`flex items-center gap-1.5 rounded-lg hover:bg-gray-100 text-sm font-medium text-[#0B2545] ${compact ? 'p-2' : 'px-3 py-2'}`}>
          <Globe className="w-4 h-4" />
          {!compact && <span>{lang === 'hi' ? 'हिन्दी' : 'English'}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setLang('en')} className={lang === 'en' ? 'font-semibold text-[#00A651]' : ''}>English</DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLang('hi')} className={lang === 'hi' ? 'font-semibold text-[#00A651]' : ''}>हिन्दी (Hindi)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
